import * as Sentry from "@sentry/browser";
import * as React from "react";
import {Suspense} from "react";
import {createRoot} from "react-dom/client";
import ShopRatingSection from "./ShopRatingSection";

export class ShopRatingHandler {
  public static run(acordionElement: HTMLElement, headlineElement: HTMLElement | null): void {
    const shopId = Number(document.body.dataset.channel);
    const data = acordionElement.dataset.reactRating;

    if (!Number.isInteger(shopId)) {
      Sentry.captureException(new Error("SalesChannelId not found in DOM"));

      return;
    }

    if (data === undefined) {
      Sentry.captureException(new Error("Data attribute for Rating ItemIDs is missing or empty."));

      return;
    }

    Sentry.setExtra("SalesChannelId", shopId);

    const itemIds = data.split(",").map(Number);
    if (itemIds.length === 0) {
      Sentry.captureException(new Error("No itemIds available"));

      return;
    }

    const Fallback: React.FC = () => (
      <div className="accordion__item__headline">
        <div className="swiper-lazy-preloader">{/* empty div for preloading spinner */}</div>
      </div>
    );

    const root = createRoot(acordionElement);
    root.render(
      <Suspense fallback={<Fallback />}>
        <ShopRatingSection itemIds={itemIds} headlineElement={headlineElement} />
      </Suspense>,
    );
  }
}
